export const BUTTON_LABELS = {
  comment: 'Comment',
  updateComment: 'Update comment',
}
